let CursosData = {
    Titulo: "Cursos",
    sub: [
        {
            subtitulo: 'Idiomas',
            item: ['Inglês Básico, UnB Idiomas.', 'Inglês Intermediário 1, UnB Idiomas.']
        },
        {
            subtitulo: 'Aprendizado de Máquina',
            item: ['Curso de Extensão: Introdução a Machine Learning e Deep Learning (IMLDL), BRASIL+IA .']
        }
    ]
}

export default CursosData